var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturnsExternalLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 76,
    viewBox: "0 0 94 76",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M57.447 27.773 37.83 39.1 18.21 27.773l19.617-11.327z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M37.83 59.21V39.1l19.616-11.328v20.111L37.828 59.21"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M37.83 59.21 18.21 47.883l.001-20.11M28.237 32.78l18.814-10.864M67.913 16.58a36.671 36.671 0 0 1 6.742 21.245c0 1.927-.148 3.82-.433 5.666M11.254 63.329c6.704 6.984 16.135 11.329 26.574 11.329A36.66 36.66 0 0 0 60.68 66.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.363 11.289C56.742 4.917 47.743 1 37.829 1 17.489 1 1 17.488 1 37.828c0 7.76 2.4 14.959 6.498 20.896",
    stroke: "#FFF",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M53.97 11.695h9.729V2.114M20.344 62.455h-9.729v9.58M90.424 48.317H67.146a2.72 2.72 0 0 0-2.72 2.721v12.488a2.72 2.72 0 0 0 2.72 2.721h5.25l5.788 5.79-.093-5.79h12.333a2.72 2.72 0 0 0 2.721-2.72V51.037a2.72 2.72 0 0 0-2.72-2.72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.148 56.93a1.776 1.776 0 1 0 3.552 0 1.776 1.776 0 0 0-3.552 0M76.666 56.93a1.776 1.776 0 1 0 3.552 0 1.776 1.776 0 0 0-3.552 0M83.185 56.93a1.776 1.776 0 1 0 3.552 0 1.776 1.776 0 0 0-3.552 0",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnsExternalLogo);
export default __webpack_public_path__ + "static/media/returns_external_logo.b877923706dddd92cc330e7cef2b726d.svg";
export { ForwardRef as ReactComponent };